import { createFileRoute } from "@tanstack/react-router";

import { BootstrapPage } from "../bootstrap/BootstrapPage";
import { advisorSignalsQueryOptions } from "../bootstrap/queries";

export const Route = createFileRoute("/_auth/bootstrap/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(advisorSignalsQueryOptions),
  component: BootstrapPage,
});
